import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=3b0a94d7&scoped=true"
import script from "./AddressDialog.vue?vue&type=script&lang=js"
export * from "./AddressDialog.vue?vue&type=script&lang=js"
import style0 from "./AddressDialog.vue?vue&type=style&index=0&id=3b0a94d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a94d7",
  null
  
)

export default component.exports